import cx from 'classnames';
import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';
import debounce from '|/helpers/debounce';
import styles from './control-panel.module.css';

const FeatureBranches = () => {
  const [showInterface, setShowInterface] = useState(false);
  const [enableFeatureOverride, setEnableFeatureOverride] = useState(false);
  const [featureOverrideName, setFeatureOverrideName] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const featureOverrideCookie = Cookies.get('cvna-feature-enable') ?? '';
    const featureNameFromCookies = Cookies.get('cvna-feature-name') ?? '';
    const pageLoadEnable = featureOverrideCookie === 'true';
    setEnableFeatureOverride(pageLoadEnable);
    setFeatureOverrideName(featureNameFromCookies);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (isLoading) {
      return;
    }
    Cookies.set('cvna-feature-enable', enableFeatureOverride.toString());
  }, [enableFeatureOverride, isLoading]);

  useEffect(() => {
    if (isLoading) {
      return;
    }
    Cookies.set('cvna-feature-name', featureOverrideName);
  }, [featureOverrideName, isLoading]);

  const isProduction = process.env.NODE_ENV === 'production';

  if (isProduction || isLoading) {
    return null;
  }

  const debounceUpdateText = debounce(setFeatureOverrideName, 50);

  return (
    <div className={styles.wrapper}>
      <button
        className={cx(styles.tab, showInterface && styles.expanded)}
        onClick={() => {
          setShowInterface(!showInterface);
        }}
        data-analytics-id="pp_devpanel_feature"
      >
        Feature Override
      </button>

      {showInterface && (
        <div className={styles.content}>
          <label htmlFor="ppcp-enable-feature" className={styles.checkbox}>
            <input
              type="checkbox"
              id="ppcp-enable-feature"
              defaultChecked={enableFeatureOverride}
              onChange={() => {
                setEnableFeatureOverride(!enableFeatureOverride);
              }}
            />
            Enable Feature Testing?
          </label>
          <div className={styles.input}>
            <label htmlFor="ppcp-feature-name">Name:</label>
            <input
              id="ppcp-feature-name"
              type="text"
              disabled={!enableFeatureOverride}
              defaultValue={featureOverrideName}
              autoComplete="none"
              spellCheck="false"
              autoCapitalize="none"
              className={styles.input}
              onChange={e => {
                debounceUpdateText(e.target.value);
              }}
            />
            <button
              data-analytics-id="ppcp-refresh-page-btn"
              className={styles.refreshBtn}
              disabled={!featureOverrideName || !enableFeatureOverride}
              onClick={() => {
                window.location.reload();
              }}
            >
              Reload Page
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FeatureBranches;
